import { createSelector } from 'reselect';

import { draftModuleSelector } from '../utils';
import { getDraftPreview } from './utils';

export const previewStateSelector = createSelector(draftModuleSelector, getDraftPreview);
